import { Avatar, Box, Drawer, Grid, Stack, Tab, Tabs, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { IMG_BASE_URL } from "src/config/constants";
import UserInfoDrawer from "./LookUserInfoDrawer";

export default function UserInfo({ name,logo, avatar, mobile, mid, enablePreview = true }) {
  const [show, setShow] = useState(false);

  return (
    <>
      <Stack
        direction="row"
        alignItems="center"
        spacing={2}
        sx={{
          display: 'inline-flex',
          cursor: enablePreview ? "pointer" : "default",
        }}
        onClick={() => {
          if (!enablePreview) return;
          setShow(true);
        }}
      >
        <Avatar alt={name} src={logo?'https://oss.xunyetech.xyz'+logo:''}/>
        <Stack>
          <Typography variant="subtitle2" noWrap>
            {name || mobile}
          </Typography>
          <Typography variant="subtitle2" noWrap>
            {mid}
          </Typography>
        </Stack>
      </Stack>
      {show && <UserInfoDrawer open uid={mid} avatar={avatar} nickname={name} onClose={() => setShow(false)} />}
    </>
  );
}
